export class DynamoDbIndexProjection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "projectionType",
            "baseName": "projectionType",
            "type": "DynamoDbProjectionType",
            "format": ""
        },
        {
            "name": "nonKeyAttributes",
            "baseName": "nonKeyAttributes",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DynamoDbIndexProjection.attributeTypeMap;
    }
    constructor() {
    }
}
